import { AnalysisItem, LegendItem, LocationData } from "helpers/models";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import getFooter from "report/common/footer";
import getHeader from "report/common/header";
import getLegend from "report/common/legend";
import getLogo from "report/common/logo";
import getMap from "report/common/map";
import { info } from "report/common/meta";
import page from "report/common/page";
import countUniquePointIds from "report/common/point";
import getReportDetail from "./detail/report";
import getEvent from "./event/event";
import getHazard from "./hazard/hazard";

interface Param {
  t: any;
  locationSet: LocationData;
  analysisItems: AnalysisItem[];
  legendItems: LegendItem[];
  eventResult: AnalysisItem[];
  eventLegend: LegendItem[];
  currency: string;
  aggregationUnits: string[];
  unit: string;
  locationsFilterInfo: any[];
}

const getDoc = async ({
  t,
  locationSet,
  analysisItems,
  legendItems,
  eventResult,
  eventLegend,
  currency,
  aggregationUnits,
  unit,
  locationsFilterInfo
}: Param): Promise<TDocumentDefinitions> => {
  const hazardCount = countUniquePointIds(analysisItems);
  const eventCount = countUniquePointIds(eventResult);
  // const totalCount = hazardCount > eventCount ? hazardCount : eventCount;
  const totalCount = locationSet.itemCount || 0;

  const docDefinition: TDocumentDefinitions = {
    pageOrientation: "landscape",

    pageMargins: [20, 60, 20, 30],

    header: (currentPage, pageCount) =>
      currentPage === 1 ? getHeader(t("report.CatNet"), 842) : getLogo(),

    footer: (currentPage, pageCount) => getFooter(t, currentPage, pageCount),

    content: [
      {
        columns: [
          {
            stack: getReportDetail(
              t,
              locationSet.name,
              totalCount,
              locationsFilterInfo,
              currency
            )
          },
          {
            stack: await getMap(t("report.Map View"))
          },
          {
            stack: await getLegend(t("report.Map Legends"))
          }
        ],
        columnGap: 20
      },

      analysisItems.length && legendItems.length ? page() : "",
      analysisItems.length && legendItems.length
        ? await getHazard(
            t,
            locationSet,
            analysisItems,
            legendItems,
            hazardCount,
            aggregationUnits,
            unit,
            currency
          )
        : "",

      eventResult.length && eventLegend.length ? page() : "",
      eventResult.length && eventLegend.length
        ? await getEvent(
            t,
            locationSet.items || [],
            eventResult,
            eventLegend,
            eventCount,
            aggregationUnits,
            unit,
            currency
          )
        : ""
    ],

    info: info,

    defaultStyle: {
      // font: getLanguage() === "en" ? "Roboto" : "微软雅黑",
      font: "普惠体",
      fontSize: 8,
      opacity: 0.6,
      lineHeight: 1,
      characterSpacing: 0
    }
  };

  return docDefinition;
};

export default getDoc;
